export const DICTIONARY = {
	open: 'Abierto',
	close: 'Cerrado',
	banned: 'Baneado',
};
